import { PureComponent } from 'react';

import CoreUtils from '../utils/CoreUtils';
import DataModel from '../model/DataModel';

export default class DataModelView extends PureComponent {
  constructor(props) {
    super(props);

    this.integratedPropertyNames = this.getIntegratedPropertyNames();
    if (CoreUtils.isUndefinedOrNull(this.integratedPropertyNames) || !Array.isArray(this.integratedPropertyNames))
      this.integratedPropertyNames = [];

    this.state = {};
    this.bindDataModel(this.props.dataModel);
  }

  componentWillUnmount() {
    this.unbindDataModel();
  }

  getIntegratedPropertyNames() { }

  bindDataModel(dataModel) {
    if (dataModel === this.dataModel)
      return;

    this.unbindDataModel();

    if (CoreUtils.isUndefinedOrNull(dataModel) || !(dataModel instanceof DataModel))
      return;

    this.dataModelPropertyListener = this.updateDataModelStateValues.bind(this);
    this.dataModel = this.props.dataModel;

    this.dataModel.addPropertyListener(
      this.integratedPropertyNames,
      this.dataModelPropertyListener
    );

    this.populateDataModelStateValues(this.state, this.integratedPropertyNames);
  }

  unbindDataModel() {
    if (CoreUtils.isUndefinedOrNull(this.dataModel))
      return;

    this.dataModel.removePropertyListener(this.dataModelPropertyListener);
    this.dataModel = null;
    this.dataModelPropertyListener = null;
  }

  updateDataModelStateValues(propertyNames) {
    var state = {};
    this.populateDataModelStateValues(state, propertyNames);
    this.setState(state);
  }

  populateDataModelStateValues(state, propertyNames) {
    var updatePropertyNames = this.integratedPropertyNames.filter(
      propertyName => propertyNames.includes(propertyName)
    );

    if (updatePropertyNames.length === 0 || CoreUtils.isUndefinedOrNull(this.dataModel))
      return;

    updatePropertyNames.forEach(
      propertyName => state[propertyName] = this.dataModel[propertyName]
    );
  }
}